/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { DependencyObject } from "./DependencyObject";
import { markType } from "./type";
/**
 * @hidden
 */
var UIElement = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(UIElement, _super);
    function UIElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.j = null;
        return _this;
    }
    UIElement.$t = markType(UIElement, 'UIElement', DependencyObject.$);
    return UIElement;
}(DependencyObject));
export { UIElement };
//# sourceMappingURL=UIElement.js.map
